/**
 * systemTask模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const systemTask = {
  // 账务创建
  createSystemTask(params) {
    return $http.post(`${global.API_URL}/task/systemTask/create`,params);
  },
  // 编辑账务
  updateSystemTask(params) {
    return $http.post(`${global.API_URL}/task/systemTask/update`,params);
  },
  //账务列表分页
  pageSystemTask(params) {
    return $http.post(`${global.API_URL}/task/systemTask/page`,params);
  },
  //账务删除
  deleteSystemTask(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/task/systemTask/delete`,param);
  },
  //开启或关闭systemTask
  changeStatus(params) {
    return $http.post(`${global.API_URL}/task/systemTask/changeStatus`,params);
  }
}

export default systemTask;



// WEBPACK FOOTER //
// ./src/api/systemTask.js